import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';

import { API_URI } from '../constants';
import auth from '../utils/auth';

const httpLink = createHttpLink({
  uri: API_URI,
});

// const httpLink = BatchHttpLink({
//   uri: API_URI,
// });

// Send JWT tokens x-token and x-refresh-token headers
const authMiddleware = setContext(() => ({
  headers: {
    'x-token': localStorage.getItem('token') || null,
    'x-refresh-token': localStorage.getItem('refreshToken') || null,
  },
}));

// Save JWT tokens to localStorage
const authAfterware = new ApolloLink((operation, forward) =>
  forward(operation).map(response => {
    const context = operation.getContext();
    const {
      response: { headers },
    } = context;

    if (headers) {
      const currentToken = localStorage.getItem('token');
      const token = headers.get('x-token');
      const refreshToken = headers.get('x-refresh-token');

      if (token) {
        localStorage.setItem('token', token);
      }

      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
      }
    }

    return response;
  })
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );

      if (message === 'Not Authorised!') {
        auth.logout(() => {
          window.location.replace('/login');
        });
      }
    });

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Combine ApolloLinks
const link = ApolloLink.from([
  authAfterware,
  authMiddleware,
  errorLink,
  httpLink,
]);

// Apollo Client cache
const cache = new InMemoryCache();

// Fallback to Apollo Client 1.0 behaviour
const defaultOptions = {
  watchQuery: {
    errorPolicy: 'none',
    fetchPolicy: 'cache-and-network',
    ssr: false,
  },
};

// Apollo client
const client = new ApolloClient({
  link,
  cache,
  defaultOptions,
});

export default client;
